export interface CertificateNote_Interface {
    id:number,
    code:String,
    dsc:String,

    subdate:String,
    username: String,
    DeletingProccess:boolean,
    del:boolean,
  }
  
  export function Empty_CertificateNote_Interface():CertificateNote_Interface{
    return{
      id:0,
      code:'',
      dsc:'',
      subdate:'',
      username:'',
      DeletingProccess:false,
      del:false,
    }
  }